import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="py-32 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-8">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24" data-id="element-9">
        <div className="lg:col-span-5 flex flex-col items-start" data-id="element-10">
          <span className="text-avm-accent text-xs font-semibold tracking-[0.2em] uppercase mb-6 block" data-id="element-11">
            About
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-avm-text" data-id="element-12">
            Partnering with operators navigating structural change.
          </h2>
        </div>

        <div className="lg:col-span-7 flex flex-col justify-end space-y-8 text-lg md:text-xl text-avm-textMuted font-light leading-relaxed" data-id="element-13">
          <p data-id="element-14">
            Atlas Ventures Management LLC (AVM) is a management and consulting
            platform focused on building and operating technology-first
            businesses within traditional industries.
          </p>
          <p data-id="element-15">
            We partner with operators and companies to navigate structural
            change — particularly the integration of data systems, automation,
            and applied AI into legacy workflows. AVM operates as an active
            management partner, not a traditional fund, bringing deep
            operational expertise to scale founder-led businesses.
          </p>
        </div>
      </motion.div>
    </section>;
}